module.exports = __webpack_public_path__ + "img/ic_cb_violet.15de67e6.svg";